import { Component, input } from '@angular/core';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { TranslatePipe } from '@ngx-translate/core';
import { DataFieldComponent } from '@myarvato/shared/data-field';
import { AddressFieldComponent } from '@myarvato/shared/address-field';

@Component({
  selector: 'transport-details-sender-recipient',
  imports: [TranslatePipe, DataFieldComponent, AddressFieldComponent],
  templateUrl: './details-sender-recipient.component.html',
  styleUrl: './details-sender-recipient.component.scss',
})
export class DetailsSenderRecipientComponent {
  public readonly details = input.required<DetailViewDto>();
}
